import { useContext, useEffect, useRef, useState } from 'react';
import { FormUtility } from '../../../Utility/FormUtility';
import Input from '../../../Form/Input';
import { useNavigate, useParams } from 'react-router-dom';
import { Libreria } from '../../../../models/Libreria';
import { LibreriaService } from '../../../../services/LibreriaService';
import Select from '../../../Form/Select';
import { BandoService } from '../../../../services/BandoService';
import { ComuneService } from '../../../../services/ComuneService';
import { rolesCodes } from '../../../../constants/Roles';
import { tipologieFase } from '../../../../constants/TipologiaFase';
import { useSelector } from 'react-redux';
import ToastContext from '../../../../contexts/toast';
import Checkbox from '../../../Form/Checkbox';
import StatusContext from '../../../../contexts/status';

export default function GestioneLibreria() {
  const [validate, setValidate] = useState(false);
  const [inputErrors, setInputErrors] = useState([]);

	const regExprFiscalCode = '^([A-Za-z]{6}[0-9LMNPQRSTUVlmnpqrstuv]{2}[ABCDEHLMPRSTabcdehlmprst][0-9LMNPQRSTUVlmnpqrstuv]{2}[A-Za-z][0-9LMNPQRSTUVlmnpqrstuv]{3}[A-Za-z])$';

  const [bandi, setBandi] = useState(null);
  const [bando, setBando] = useState(null);

  const [codiciFiscaliErrati, setCodiciFiscaliErrati] = useState([]);

  const [disabledForm, setDisabledForm] = useState(true);
  const [startup, setStartup] = useState(false);

  const [libreria, setLibreria] = useState(new Libreria());

  const libreriaService = new LibreriaService();
  const bandoService = new BandoService();
  const comuneService = new ComuneService();

  const userRoles = useSelector((state) => state.role);
  const utility = new FormUtility({ data: userRoles });

  const toastContext = useContext(ToastContext);
  const statusContext = useContext(StatusContext);

  const params = useParams();
  const navigation = useNavigate();
	const formRef = useRef(null);

  useEffect(() => {
    bandoService.getAll().then(resp => {
      setBandi(resp);

      if (!params.id) {
        const bando = resp.find(b => b.fasi.find(f => f.tipologia === tipologieFase.censimento_librerie));
        const fase = bando ? bando.fasi.find(el => el.tipologia === tipologieFase.censimento_librerie) : null;
        setDisabledForm(!utility.checkFaseIsActive(fase, 'dataInizio', 'dataFineCensimento', 'YYYY-MM-DD', 'YYYY-MM-DD'));
        setBando(bando);
      }
    });

    const paramId = params.id;
    if (paramId) {
      libreriaService.getById(paramId).then(resp => {
        setLibreria({ ...resp });
        setBando(resp.bando);
      }).catch(error => {
        console.log(error);
      });
    } else {
      comuneService.getById(params.enteId).then(resp => {
        libreria.comune = resp;
      });
    }

    return () => {
      statusContext.removeEvent('onbeforeunload');
    }
  }, []);

  useEffect(() => {
    if (!startup && bando && Object.keys(libreria).length > 0) {
      let checkDisabled = libreria.richieste?.length > 0;
      if (utility.checkRoles([rolesCodes.comune])) {
        const fase = bando.fasi.find(f => f.tipologia === tipologieFase.censimento_librerie);
        checkDisabled = checkDisabled || !utility.checkFaseIsActive(fase, 'dataInizio', 'dataFineCensimento', 'YYYY-MM-DD', 'YYYY-MM-DD');
      }
      setDisabledForm(checkDisabled);
      setStartup(true);
    }
  }, [bando, libreria, startup]);

	const onChangeValue = async (event, field = 'value') => {
		const target = event.target;
    libreria[target.name] = target[field];
    setLibreria({ ...libreria });

    statusContext.addEvent('onbeforeunload')

    if (validate) {
      setFormErrors(false);
    }
	}

  const aggiungiOperatore = () => {
    if (!libreria.operatori) {
      libreria.operatori = [];
    }

    const codiceFiscale = libreria.operatore.toUpperCase();

    const index = libreria.operatori.map(op => op.codiceFiscale).indexOf(codiceFiscale);
    if (index >= 0) {
      toastContext.error('Operatore già associato alla libreria', 8000);
      return;
    }

    libreria.operatori.push({ id: null, codiceFiscale: codiceFiscale });
    libreria.operatore = '';
    setLibreria({ ...libreria });
  }

  const rimuoviOperatore = (codiceFiscale) => {
    const index = libreria.operatori.map(op => op.codiceFiscale).indexOf(codiceFiscale);
    libreria.operatori.splice(index, 1);
    setLibreria({ ...libreria });

    statusContext.addEvent('onbeforeunload')
  }

  const setFormErrors = (setFocus = true) => {
    const errors = utility.getAllInputErrors(formRef);
    setInputErrors(errors.map(el => el.id));
    if (setFocus && errors.length > 0) {
      errors[0].focus();
    }
  }

  const denyOperation = () => {
    navigation(`/gestione-librerie/${params.enteId}`);
  }

  const checkFieldValidity = (field, minLength, maxLength, bypassValidate = false) => {
    if (!bypassValidate && !validate) {
      return '';
    }

    const value = libreria[field];
		if (!value) {
			return 'Campo obbligatorio';
		}

		if (value.length < minLength) {
			return 'Deve avere lunghezza ' + minLength;
		}

		if (value.length < maxLength) {
			return 'Deve avere lunghezza ' + maxLength;
		}

    if (field === 'operatore') {
      const re = new RegExp(regExprFiscalCode);
      if (!re.test(value.toUpperCase())) {
        return 'Il campo non rispetta lo schema riconosciuto';
      }
    }

		return '';
  }

  const sendData = (event) => {
		event.preventDefault();
		event.stopPropagation();

    setValidate(true);

    const validity = formRef.current.checkValidity();
    if (!validity) {
      setFormErrors();
      return;
    }

    setInputErrors([]);

    libreria.partitaIva = libreria.partitaIva.toUpperCase();
    libreria.bando = bando;
    libreria.comuniAssociati = libreria.comuniAssociati ?? [];

    const service = params.id ? libreriaService.update : libreriaService.create;
		service(libreria).then(() => {
      toastContext.success('Libreria ' + (params.id ? 'aggiornata' : 'aggiunta') + ' con successo!', 6000);
			statusContext.removeEvent('onbeforeunload');

			setTimeout(() => {
				navigation(`/gestione-librerie/${params.enteId}`);
			}, 100);
		}).catch(error => {
      const baseError = 'Uno o più operatori indicati sono già associati da un\'altra libreria';
      const errMessage = utility.getErrorMsg(error, baseError);
      toastContext.error(errMessage, 12000);
      if (errMessage === baseError) {
        setCodiciFiscaliErrati([ ...error.response.data ]);
      }
		});
  }

  return (
    <div className='rtds-container rtds-my-12'>
      <div className='rtds-mb-6'>
        <h1 className='rtds-text-2xl rtds-font-bold'>{params.id ? 'Modifica' : 'Inserimento'} Libreria</h1>
      </div>
      <div className='rtds-background-01 rtds-p-6 rtds-border rtds-border-gray-02'>
        <div className='rtds-pb-6 rtds-space-y-4 rtds-border-b rtds-border-gray-02'>
          <p>
            I campi obbligatori sono contrassegnati da un asterisco&nbsp; 
            <abbr
              className='rtds-font-bold rtds-no-underline'
              title='obbligatorio'
            >
              *
            </abbr>
          </p>
        </div>

        <form
          noValidate ref={formRef}
          id='hasValidationForm'
          className='has-js-validation-form rtds-py-6 rtds-space-y-4'
          onSubmit={sendData}
        >
          <Select
            classDiv={'rtds-mt-3 lg:rtds-mt-0'}
            label={'Avviso'}
            required
            id={'bando_id'}
            inputErrors={inputErrors}
            classSelect={''}
            baseOption={'Seleziona Avviso'}
            bindKey={'id'}
            bindValue={'nome'}
            options={bandi}
            value={bando?.id || libreria.bando_id || ''}
            disabled
          />
          <div className='rtds-field-row'>
            <Input
              label={'Nome'}
              required
              id={'nome'}
              inputErrors={inputErrors}
              classInput={'rtds-text-sm rtds-input-placeholder rtds-pr-12'}
              type={'text'}
              onChange={(event) => onChangeValue(event)}
              value={libreria.nome || ''}
              disabled={disabledForm}
            />
            <Input
              classDiv={'rtds-mt-3 lg:rtds-mt-0'}
              label={'Partita IVA'}
              required
              id={'partitaIva'}
              inputErrors={inputErrors}
              classInput={'rtds-text-sm rtds-input-placeholder rtds-uppercase'}
              type={'text'}
              minLength={11}
              maxLength={11}
              onChange={(event) => onChangeValue(event)}
              value={libreria.partitaIva || ''}
              errorMessage={!libreria.partitaIva ? 'Campo obbligatorio' : libreria.partitaIva.length !== 11 ? 'Deve essere di lunghezza 11' : ''}
              disabled={disabledForm}
            />
          </div>

          <div className='rtds-field-row'>
            <Input
              label={'Indirizzo'}
              required
              id={'indirizzo'}
              inputErrors={inputErrors}
              classInput={'rtds-text-sm rtds-input-placeholder rtds-pr-12'}
              type={'text'}
              onChange={(event) => onChangeValue(event)}
              value={libreria.indirizzo || ''}
              disabled={disabledForm}
            />
            <Input
              classDiv={'rtds-mt-3 lg:rtds-mt-0'}
              label={'N. Civico'}
              required
              id={'civico'}
              inputErrors={inputErrors}
              classInput={'rtds-text-sm rtds-input-placeholder rtds-pr-12'}
              type={'tel'}
              onChange={(event) => onChangeValue(event)}
              value={libreria.civico || ''}
              disabled={disabledForm}
            />
            <Input
              classDiv={'rtds-mt-3 lg:rtds-mt-0'}
              label={'CAP'}
              required
              id={'cap'}
              inputErrors={inputErrors}
              classInput={'rtds-text-sm rtds-input-placeholder rtds-pr-12'}
              type={'tel'}
              onChange={(event) => onChangeValue(event)}
              value={libreria.cap || ''}
              disabled={disabledForm}
              minLength={5}
              maxLength={5}
              errorMessage={checkFieldValidity('cap', 5, 5)}
            />
            <Input
              classDiv={'rtds-mt-3 lg:rtds-mt-0'}
              label={'Comune'}
              id={'comune_id'}
              classInput={'rtds-text-sm rtds-input-placeholder rtds-pr-12'}
              type={'text'}
              onChange={(event) => onChangeValue(event)}
              value={libreria.comune?.denominazione || ''}
              disabled={true}
            />
          </div>

          <Checkbox
            classDiv={'rtds-input-checkbox rtds-input--lg'}
            label={'Richiede Associazione Tesseramento'}
            id={'richiedeAssociazioneTesseramento'}
            inputErrors={inputErrors}
            classInput={''}
            onChange={(event) => onChangeValue(event, 'checked')}
            checked={libreria.richiedeAssociazioneTesseramento || false}
            disabled={disabledForm}
          />

          <h2 id='operatoriAssociatiTitle' className='rtds-input-field__label'>
            Operatori Associati
          </h2>
          {
            libreria.operatori?.length === 0
              ? ''
              : <ul aria-labelledby='operatoriAssociatiTitle'>
                  {
                    libreria.operatori?.map((operatore) => (
                      <li className={'rtds-mb-3 rtds-aling-center rtds-flex' + (codiciFiscaliErrati.includes(operatore.codiceFiscale.toUpperCase() ? ' rtds-content-error' : ''))} key={operatore.codiceFiscale}>
                        <button
                           type='button'
                           className='rtds-btn rtds-btn--icon rtds-btn--secondary rtds-btn--s'
                           title={'Premi per rimuovere coperatore all\'elenco'}
                           onClick={() => rimuoviOperatore(operatore.codiceFiscale)}
                         >
                           <svg
                             className='rtds-icon rtds-fill-current rtds-w-4 rtds-h-4'
                             aria-hidden='true'
                             focusable='false'
                             role='img'
                           >
                             <use
                               xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--minus`}
                             />
                           </svg>
                           <span className='rtds-sr-only'>Rimuovi operatore dall'elenco</span>
                        </button>
                        &nbsp;{operatore.codiceFiscale}
                      </li>
                    ))
                  }
                </ul>
          }

          <Input
            classDiv={'rtds-mt-3 lg:rtds-mt-0'}
            label={'Codice Fiscale Operatore'}
            classLabel={'rtds-sr-only'}
            classInput={'rtds-uppercase sx-border-right rtds-text-sm rtds-input-placeholder'}
            classDivInput={'rtds-flex rtds-input'}
            id={'operatore'}
            pattern={regExprFiscalCode}
            inputErrors={inputErrors}
            placeholder='Inserisci Codice Fiscale operatore'
            onChange={(event) => onChangeValue(event)}
            errorMessage={checkFieldValidity('operatore', 16, 16)}
            value={libreria.operatore || ''}
            minLength={16}
            maxLength={16}
            elementExtender={
              <button
                type='button'
                className={`rtds-btn rtds-border-2 sx-border-left ${
                  checkFieldValidity('operatore', 16, 16, true) ? 'rtds-button-disabled sx-not-allowed' : 'rtds-btn--primary'
                }`}
                onClick={() => aggiungiOperatore()}
                disabled={checkFieldValidity('operatore', 16, 16, true) ? true : false}
                title={'Premi per aggiungere operatore all\'elenco'}
              >
                <svg
                  className='rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6'
                  aria-hidden='true'
                  focusable='false'
                  role='img'
                >
                  <use
                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--plus`}
                  />
                </svg>
                <span className='rtds-sr-only'>Aggiungi operatore all'elenco</span>
              </button>
            }
          />
       
          <div className='rtds-border-gray-02 rtds-border-b rtds-border-t rtds-p-3 rtds-flex sm:justify-end justify-center'>
            <div className='rtds-form-actions'>
              <div
                className='rtds-inline-flex rtds-gap-1'
                role='group'
                aria-label='Azioni'
              >
                <button
                  type='button'
                  className='rtds-btn rtds-btn--secondary rtds-form-submit rtds-btn--icon-left rtds-group/button'
                  onClick={() => denyOperation()}
                >
                  <svg
                    className='rtds-icon rtds-fill-current rtds-w-6 rtds-h-6 group-hover/button:-rtds-translate-x-1'
                    aria-hidden='true'
                    focusable='false'
                    role='img'
                  >
                    <use
                      xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--arrow-uturn-left`}
                    />
                  </svg> Annulla
                </button>
                <button
                  type='submit'
                  className='rtds-btn rtds-btn--primary rtds-form-submit rtds-btn--icon-left rtds-group/button'
                >
                  <svg
                    className='rtds-icon rtds-fill-current rtds-w-6 rtds-h-6 rtds-transform group-hover/button:-rtds-translate-x-1'
                    aria-hidden='true'
                    focusable='false'
                    role='img'
                  >
                  <use
                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#${params.id ? 'solid--pencil-square ' : 'solid--plus-circle'}`}
                    />
                  </svg> {params.id ? 'Modifica' : 'Inserisci'}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
